import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import { Box, Typography } from '@mui/material';
import { SUBSCRIPTION_PLAN as SUBSCRIPTION_PLAN_LINK } from 'constants/paths';

import { ReactComponent as ExclamationCircleIcon } from 'assets/icons/ExclamationCircleIcon.svg';

import styles from './UpgradePlanTooltip.module.scss';

import scssVariables from 'styles/sass-variables.module.scss';

export const UpgradePlanTooltip: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box className={styles.tooltipContainer}>
      <Box className={styles.tooltipIcon}>
        <ExclamationCircleIcon fill={scssVariables.orange_600} width={32} height={32} />
      </Box>
      <Typography variant="subtitle2" onClick={() => navigate(SUBSCRIPTION_PLAN_LINK)} className={styles.tooltipText}>
        <Link to="/subscription-plans" className={styles.linkStyle}>
          {t('upgradePlanToGetFeature1')}
        </Link>{' '}
        {t('upgradePlanToGetFeature2')}
      </Typography>
    </Box>
  );
};
